export const updateResourceExplorerGcpBillingExportDataFixedCacheKey =
  "update-resource-gcp-billing-export-data";

export const createResourceExplorerGcpBillingExportDataFixedCacheKey =
  "create-resource-gcp-billing-export-data";
